__turbopack_context__.v({
  "layout": "Layout-module-scss-module__fMTt7W__layout",
});
